/* コレクション playful 版の動き
   - カード登場：スクロールで下からふわっと、2列ごとに約0.09sずらし
   - 学年チップ：押すとポンと弾む（※絞り込みロジックには触れない・見た目だけ）
   見本：collection-playful.html / 仕様：prefers-reduced-motion で停止 */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.collection').forEach(function (col) {
    // ---- カード登場 ----
    if (!reduce) {
      col.classList.add('pl-ready'); // これが付いた時だけCSSがカードを一旦隠す（JS未到達なら見えたまま）
      var cards = [].slice.call(col.querySelectorAll('.card-wrapper'));

      var reveal = function (el) {
        var i = parseInt(el.getAttribute('data-pl-i'), 10) || 0;
        el.style.animationDelay = ((i % 2) * 0.09) + 's';
        el.classList.add('pl-in');
      };

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); }
          });
        }, { threshold: 0.12 });
        cards.forEach(function (c, i) { c.setAttribute('data-pl-i', i); io.observe(c); });
        // フェイルセーフ：万一観測が発火しないカードも一定時間後に必ず表示
        setTimeout(function () { cards.forEach(reveal); }, 1500);
      } else {
        cards.forEach(function (c) { c.classList.add('pl-in'); });
      }
    }

    // ---- 学年チップの弾み（見た目だけ。data-grade等の絞り込みは age-filter.js のまま）----
    col.querySelectorAll('.age-chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        chip.classList.remove('pl-pop');
        void chip.offsetWidth; // リフローでアニメを確実に再生
        chip.classList.add('pl-pop');
      });
    });
  });
})();
